<template>
  <div>
    <div v-if="vistaListasControles === 1">
      <FormularioControles @vModalControles="vModalControles" @cambiarVistaListasControles="cambiarVistaListasControles"></FormularioControles>
    </div>
    <div v-else>
      <FormularioListas @vModalListas="vModalListas" @cambiarVistaListasControles="cambiarVistaListasControles"></FormularioListas>
      <!--MODAL LISTAS-->
    </div>
    <!--MODAL CONTROLES-->
    <b-modal
      id="modal-1"
      ref="modal_controles"
      :title="accionControl + ' control'"
      size="md"
      hide-footer
    >
      <ModalControles @vModalControles="vModalControles"></ModalControles>
    </b-modal>
    <b-modal
      id="modal-2"
      ref="modal_listas"
      :title="accionLista + ' Lista'"
      size="md"
      hide-footer
    >
      <ModalListas @vModalListas="vModalListas"></ModalListas>
    </b-modal>
  </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import ModalListas from "./Modales/ModalListas.vue";
import ModalControles from "./Modales/ModalControles.vue";
import FormularioControles from "./Formularios/FormularioControles.vue"
import FormularioListas from "./Formularios/FormularioListas.vue"

export default {
  name: "controles",
  data() {
    return {
      vistaListasControles: 1,     
      control: "",
    };
  },
  components: {
    ModalListas,
    ModalControles,
    FormularioControles,
    FormularioListas
},
  methods: {
    async vModalControles(boolean) {
      if (boolean) {
        this.$refs.modal_controles.show();
      } else {
        this.$refs.modal_controles.hide();
      }
    },
    async vModalListas(boolean) {
      if (boolean) {
        this.$refs.modal_listas.show();
      } else {
        this.$refs.modal_listas.hide();
      }
    },
    async cambiarVistaListasControles(vista) {
      this.vistaListasControles = vista;
    },
    cambiarVistaControles(vista) {
      this.vistaListasControles = vista;
    },
    creaCont() {
      this.resetSelectedControl();
      this.$refs.modal_controles.show();
    },
    creaLista() {
      this.resetSelectedLista();
      this.$refs.modal_controles.show();
    },
    async nuevoControl() {
      if (this.accionControl == "Crear") {
        await this.crearControl();
      } else {
        await this.actualizarControl();
      }
      await this.getControles();
      this.$refs.modal_controles.hide();
      this.resetSelectedControl();
    },
    async buscadorControl(buscar) {
      this.setPageControles(1);
      this.setFiltroControles(buscar);
      await this.getControles();
    },
    async buscadorLista(buscar) {
      this.setPageListas(1);
      this.setFiltroListas(buscar);
      await this.getListas();
    },
    async nuevaLista() {
      if (this.accionLista == "Crear") {
        this.filtroListas.id_control = this.selectedListas.id_control;
        await this.crearLista();
        await this.getListas();
      } else {
        this.filtroListas.id_control = this.selectedListas.id_control;
        await this.actualizarLista();
        await this.getListas();
      }
      this.resetSelectedLista();
    },
    async verListaControl(data) {
      this.resetFiltroListas();
      this.control = data.control;
      this.setFiltLista(data.id);
      await this.getListas();
      this.vistaListasControles = 2;
    },
    async verLista(id) {
      await this.mostrarLista(id);
      this.$refs.modal_listas.show();
    },
    async activarInactivarLista(item) {
      item.activo = item.activo === 1 ? 0 : 1;
      this.setLista(item);
      await this.actualizarLista();
      await this.getListas();
    },
    async activarInactivarControl(item) {
      item.activo = item.activo === 1 ? 0 : 1;
      this.setControl(item);
      await this.actualizarControl();
      await this.getControles();
    },
    async limpiarControl() {
      this.resetFiltroControles();
      await this.getControles();
    },
    async limpiarLista() {
      this.resetFiltroListas();
      await this.getListas();
    },
    ...mapActions("administracion", [
      "getControles",
      "getListas",
      "crearLista",
      "setPagePaginationControles",
      "setPagePaginationListas",
      "crearControl",
      "mostrarControl",
      "actualizarControl",
      "mostrarLista",
      "actualizarLista",
      "setPerPagePaginationControles",
      "setPerPagePaginationListas",
    ]),
    ...mapMutations("administracion", [
      "resetSelectedControl",
      "resetSelectedLista",
      "setFiltLista",
      "setPageControles",
      "setPageListas",
      "setFiltroControles",
      "setFiltroListas",
      "resetFiltroControles",
      "resetFiltroListas",
      "setControl",
      "setLista",
    ]),
  },
  computed: {
    ...mapState("administracion", [
      "selectedControl",
      "selectedLista",
      "filtroControles",
      "filtroListas",
      "controles",
      "listas",
      "selectedControles",
      "selectedListas",
      "accionControl",
      "accionLista",
      "visualizarModalControles"
    ]),
  },
};
</script>

<style scoped>
.permisos {
  display: block;
  height: 400px;
  overflow: scroll;
}
</style>
